import { Component } from '@angular/core';

@Component({
    selector: 'app-apexcharts',
    templateUrl: './apexcharts.component.html',
    styleUrls: ['./apexcharts.component.scss']
})
export class ApexchartsComponent {}